<div class="container-fluid" *ngIf="!isLoader; else loadingTemplate">
  <!-- PDF Export Button -->
  <div class="row my-3 no-export">
    <div class="col-12 text-end">
      <button class="btn btn-primary btn-download" (click)="exportToPdf()"
        [disabled]="disableButton || !productHistoryData">
        <i class="fas fa-download me-2"></i>
        {{ disableButton ? 'Generating PDF...' : 'Download PDF Report' }}
      </button>
    </div>
  </div>

  <!-- PDF Template -->
  <div id="report-template" class="pdf-template" *ngIf="productHistoryData">

    <style>
      tr {
        page-break-inside: avoid !important;
        break-inside: avoid-page !important;
      }

      .test-image {
        max-width: 150px !important;
        max-height: 120px !important;
        page-break-inside: avoid !important;
        break-inside: avoid-page !important;
      }

      .image-with-timestamp {
        page-break-inside: avoid !important;
        break-inside: avoid-page !important;
      }
    </style>

    <!-- Header Section -->
    <div class="report-header">
      <div class="row align-items-center justify-content-between">
        <div class="col-6 text-start">
          <h1 class="report-title">PRODUCT HISTORY REPORT</h1>
          <p class="report-subtitle">{{ productHistoryData?.department_name }}</p>
          <div class="report-meta mt-2">
            <p class="mb-1"><strong>Production Date :</strong> {{ formatDate(productHistoryData.date_time) }}</p>
          </div>
        </div>
        <div class="col-3 text-end">
          <img src="assets/img/img1.jpeg" alt="Company Logo" class="logo">
        </div>
      </div>
    </div>

    <!-- Order Summary Section -->
    <div class="bottom-border">
      <div class="section">
        <h2 class="section-title">1. Production Summary</h2>
        <div class="row">
          <div class="col-6">
            <table class="info-table">
              <tr>
                <td><strong>Intermediate Product Name :</strong></td>
                <td>{{ productHistoryData?.products[0]?.item_name || '-' }}</td>
              </tr>
              <tr>
                <td><strong>Intermediate Production Order Number :</strong></td>
                <td>{{ productHistoryData.order_number || '-' }}</td>
              </tr>
              <tr>
                <td><strong>Intermediate Product Code :</strong></td>
                <td>{{ productHistoryData?.products[0]?.item_code || '-' }}</td>
              </tr>
            </table>
          </div>
          <div class="col-6">
            <table class="info-table">
              <tr>
                <td><strong>Intermediate Output Qty :</strong></td>
                <td>{{ productHistoryData?.production_details?.output_qty | number:'1.2-2' || '-' }}</td>
              </tr>
              <tr>
                <td><strong>Intermediate Batch Number :</strong></td>
                <td>{{ productHistoryData?.products[0]?.batch || '-' }}</td>
              </tr>
              <tr>
                <td><strong>Tank Number :</strong></td>
                <td>{{ productHistoryData.tag_card_details?.tank_no || '-' }}</td>
              </tr>
              <tr>
                <td><strong>Category Name :</strong></td>
                <td>{{ productHistoryData.tag_card_details?.category?.category_name || '-' }}</td>
              </tr>
              <tr>
                <td><strong>Status :</strong></td>
                <td>
                  <span [class]="'status-badge ' + getStatusBadgeClass(productHistoryData.process_status)">
                    {{ productHistoryData.process_status || '-' }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Product Details Section -->
      <div class="section">
        <h2 class="section-title">1.1 FG Names</h2>
        <div *ngIf="productHistoryData?.packing_order_lists?.length > 0; else noFgData">
          <div class="product-card" *ngFor="let fgDetail of productHistoryData?.packing_order_lists; let i = index">
            <div class="row align-items-center">
              <div class="col-1">
                <h4><strong>{{ i + 1 }} .</strong></h4>
              </div>
              <div class="col-8">
                <h4><strong>FG Product Name :</strong> {{ fgDetail?.products[0]?.item_name || '-' }}</h4>
                <p class="product-code">Packing Production Order Number : {{ fgDetail?.order_number || '-'
                  }}</p>
              </div>
              <div class="col-3 text-end">
                <div class="quantity-display">
                  <span class="quantity">{{ fgDetail?.products[0]?.quantity | number:'1.2-2' || '0.00' }}</span>
                  <span class="uom">{{ fgDetail?.products[0]?.uom_name || '' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noFgData>
          <div class="no-data-section">
            <p>No FG Data Found</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Raw Materials Section -->
    <div class="section">
      <h2 class="section-title">2. Raw Materials Details Summary</h2>
      <div *ngIf="productHistoryData?.rm_lists?.length > 0; else noRmData">
        <div class="product-card" *ngFor="let RmDetail of productHistoryData?.rm_lists; let i = index">
          <div class="row align-items-center border-line">
            <div class="col-1">
              <h4><strong>{{ i + 1 }} .</strong></h4>
            </div>
            <div class="col-11">
              <h4><strong>Material Name :</strong> {{ RmDetail?.item_name || '-' }}</h4>
              <p class="product-code">Product Code : {{ RmDetail?.item_code || '-' }}</p>
              <p>Total Test Methods : <strong>{{ RmDetail?.batch[0]?.rm_qc_datas?.length || 0 }}</strong></p>
            </div>
          </div>
          <div *ngIf="RmDetail?.batch[0]?.rm_qc_datas?.length > 0; else noRmQcData">
            <div class="row mt-2 align-items-center border-line"
              *ngFor="let batchDetail of RmDetail?.batch[0]?.rm_qc_datas; let j = index">
              <div class="col-1"><strong>{{ i + 1 }}.{{ j + 1 }}</strong></div>
              <div class="col-6">
                <table class="info-table">
                  <tr>
                    <td><strong>Batch Number :</strong></td>
                    <td>{{ batchDetail?.batch_no || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Warehouse :</strong></td>
                    <td>{{ batchDetail?.grn_details?.warehouse_details?.warehouse_name || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Technician :</strong></td>
                    <td>{{ batchDetail?.technician?.employee_name || '-' }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-5">
                <table class="info-table">
                  <tr>
                    <td><strong>Decision :</strong></td>
                    <td>{{ batchDetail?.decision || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Received Date:</strong></td>
                    <td>{{ formatDate(batchDetail?.grn_details?.date_time) || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Reason :</strong></td>
                    <td>{{ batchDetail?.reason || '-' }}</td>
                  </tr>
                </table>
              </div>
              <h4 class="mt-3 text-center"><strong>QC Test Results</strong></h4>
              <div *ngIf="batchDetail?.qc_methods?.length > 0; else noQcMethods">
                <table class="data-table mt-1">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Method Name</th>
                      <th>Test Type</th>
                      <th>Technician</th>
                      <th>Method Code</th>
                      <th>UOM</th>
                      <th>Minimum</th>
                      <th>Maximum</th>
                      <th>Test Result</th>
                      <th>Test Image & Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let qcTestResults of batchDetail?.qc_methods; let i = index">
                      <td>{{ i + 1 }} .</td>
                      <td class="text-start">{{ qcTestResults?.test_method_name || '-' }}</td>
                      <td>{{ qcTestResults?.test_type || '-' }}</td>
                      <td>
                        <span *ngIf="qcTestResults?.test_result; else noTechnician">
                          {{ qcTestResults?.technician_name ||
                          RmDetail?.batch[0]?.rm_qc_datas[j]?.technician?.employee_name || '-' }}
                        </span>
                        <ng-template #noTechnician>-</ng-template>
                      </td>
                      <td>{{ qcTestResults?.test_method_code || '-' }}</td>
                      <td>{{ qcTestResults?.uom_name || '-' }}</td>
                      <td>{{ qcTestResults.minimum | number:'1.2-2' || '-' }}</td>
                      <td>{{ qcTestResults.maximum | number:'1.2-2' || '-' }}</td>
                      <!-- <td>{{ qcTestResults.test_result || '-' }}</td> -->
                      <td [ngClass]="{'text-danger': shouldShowRed(qcTestResults)}">
                        {{ qcTestResults.test_result || '-' }}
                      </td>
                      <td>
                        <div class="image-with-timestamp avoid-pdf-break">
                          <img *ngIf="qcTestResults.test_image" [src]="qcTestResults?.test_image" alt="Test Image"
                            class="test-image avoid-pdf-break" />
                          <div *ngIf="qcTestResults.test_image && qcTestResults.test_image_time" class="timestamp">
                            {{ formatTimestamp(qcTestResults.test_image_time) }}
                          </div>
                          <span *ngIf="!qcTestResults?.test_image">-</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noQcMethods>
                <div class="no-data-section">
                  <p>No QC Methods Data Found</p>
                </div>
              </ng-template>
            </div>
          </div>
          <ng-template #noRmQcData>
            <div class="no-data-section">
              <p>No RM QC Data Found</p>
            </div>
          </ng-template>
        </div>
      </div>
      <ng-template #noRmData>
        <div class="no-data-section">
          <p>No Raw Materials Data Found</p>
        </div>
      </ng-template>
    </div>

    <div class="section">
      <h2 class="section-title">3. Intermediate Production Process Details Summary</h2>
      <div class="row">
        <div class="col-6">
          <table class="info-table">
            <tr>
              <td><strong>Date :</strong></td>
              <td>{{ formatDate(productHistoryData?.production_details?.date_time) || '-' }}</td>
            </tr>
            <tr>
              <td><strong>Department :</strong></td>
              <td>{{ productHistoryData?.department_name || '-' }}</td>
            </tr>
            <tr>
              <td><strong>Entity :</strong></td>
              <td>{{ productHistoryData?.entity || '-' }}</td>
            </tr>
            <tr>
              <td><strong>Defined QTY :</strong></td>
              <td>{{ productHistoryData?.production_details?.inventory_quantity | number:'1.2-2' || '-' }}
              </td>
            </tr>
            <tr>
              <td><strong>Charged QTY :</strong></td>
              <td>{{ productHistoryData?.production_details?.inventory_actual_quantity | number:'1.2-2' || '-' }}</td>
            </tr>
          </table>
        </div>
        <div class="col-6">
          <table class="info-table">
            <tr>
              <td><strong>Output QTY :</strong></td>
              <td>{{ productHistoryData?.production_details?.output_qty | number:'1.2-2' || '-' }}</td>
            </tr>
            <tr>
              <td><strong>Loss % :</strong></td>
              <td>{{ productHistoryData?.production_details?.loss_percentage | number:'1.2-2' || '-' }}</td>
            </tr>
            <tr>
              <td><strong>Status :</strong></td>
              <td>{{ productHistoryData?.production_details?.production_status || '-' }}</td>
            </tr>
            <tr>
              <td><strong>Remarks :</strong></td>
              <td>{{ productHistoryData?.production_details?.remarks || '-' }}</td>
            </tr>
          </table>
        </div>
      </div>

      <h2 class="section-title mt-3">3.1 Milling Details</h2>
      <div *ngIf="productHistoryData?.milling_process_details?.length > 0; else noMillingData">
        <div class="product-card" *ngFor="let milling of productHistoryData?.milling_process_details; let i = index">
          <div class="border-line">
            <div class="row align-items-center">
              <div class="col-6">
                <table class="info-table">
                  <tr>
                    <td><strong>Passing Number :</strong></td>
                    <td>{{ milling?.passing_number || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Machine Name :</strong></td>
                    <td>{{ milling?.machine_name || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>RPM :</strong></td>
                    <td>{{ milling?.RPM || '-' }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-6">
                <table class="info-table">
                  <tr>
                    <td><strong>Flow Rate :</strong></td>
                    <td>{{ milling?.flow_rate || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Duration (min) :</strong></td>
                    <td>{{ milling?.duration | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Status :</strong></td>
                    <td>{{ milling?.status || '-' }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div *ngIf="milling?.time_logs?.length > 0">
              <h4 class="mt-3 text-center"><strong>Time Logs</strong></h4>
              <table class="data-table mt-1">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Operator Name</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let log of milling?.time_logs; let j = index">
                    <td>{{ j + 1 }}</td>
                    <td>{{ log?.operator_name || '-' }}</td>
                    <td>{{ formatTimestamp(log?.start_time) }}</td>
                    <td>{{ formatTimestamp(log?.end_time) }}</td>
                    <td>{{ log?.status || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noMillingData>
        <div class="no-data-section">
          <p>No Milling Details Data Found</p>
        </div>
      </ng-template>
      <h2 class="section-title mt-3">3.2 RM Changes</h2>
      <div *ngIf="productHistoryData?.rm_change_lists?.length > 0; else noRmChanges">
        <table class="data-table mt-1">
          <thead>
            <tr>
              <th>#</th>
              <th>Stage</th>
              <th>Defined Item Name</th>
              <th>Defined Item Quantity</th>
              <th>Alternative Item Name</th>
              <th>Alternative Item Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rmChangeDetails of productHistoryData?.rm_change_lists; let i = index">
              <td>{{ i + 1 }} .</td>
              <td>{{ rmChangeDetails?.stage || '-' }}</td>
              <td>{{ rmChangeDetails?.define_rm_item_name || '-' }}</td>
              <td>{{ rmChangeDetails?.define_rm_qty | number:'1.2-2' || '0.00' }}</td>
              <td>{{ rmChangeDetails?.alternative_rm_item_name || '-' }}</td>
              <td>{{ rmChangeDetails?.alternative_rm_qty | number:'1.2-2' || '0.00' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noRmChanges>
        <div class="no-data-section">
          <p>No RM Changes Data Found</p>
        </div>
      </ng-template>

      <h2 class="section-title mt-3">3.3 Inventory Details</h2>
      <div *ngIf="productHistoryData?.production_details?.inventory?.length > 0; else noInventoryData">
        <div class="product-card"
          *ngFor="let inventoryDetail of productHistoryData?.production_details?.inventory; let i = index">
          <div class="border-line">
            <div class="row align-items-center">
              <div class="col-1">
                <h4><strong>{{ i + 1 }} .</strong></h4>
              </div>
              <div class="col-6">
                <table class="info-table">
                  <tr>
                    <td><strong>Stage :</strong></td>
                    <td><strong>{{ inventoryDetail?.stage || '-' }}</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Material Name :</strong></td>
                    <td>{{ inventoryDetail?.item_name || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Product Code :</strong></td>
                    <td>{{ inventoryDetail?.item_code || '-' }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-5">
                <table class="info-table">
                  <tr>
                    <td><strong>Defined QTY :</strong></td>
                    <td>{{ inventoryDetail?.quantity | number:'1.2-2' || '0.00' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Charged QTY :</strong></td>
                    <td>{{ inventoryDetail?.actual_quantity | number:'1.2-2' || '0.00' }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div *ngIf="inventoryDetail?.batch?.length > 0; else noBatchData">
              <table class="data-table mt-1">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Batch Number</th>
                    <th>Employee Name</th>
                    <th>Batch Image & Time</th>
                    <th>QTY Image & Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let batchDetails of inventoryDetail?.batch; let i = index">
                    <td>{{ i + 1 }} .</td>
                    <td class="text-start">{{ batchDetails?.batch_name || '-' }}</td>
                    <td>{{ batchDetails?.responsible_employee_name || '-' }}</td>
                    <td>
                      <div class="image-with-timestamp avoid-pdf-break">
                        <img *ngIf="batchDetails?.batch_image" [src]="batchDetails?.batch_image" alt="Batch Image"
                          class="test-image avoid-pdf-break" />
                        <div *ngIf="batchDetails?.batch_image && batchDetails?.batch_img_time" class="timestamp">
                          {{ formatTimestamp(batchDetails.batch_img_time) }}
                        </div>
                        <span *ngIf="!batchDetails?.batch_image">-</span>
                      </div>
                    </td>
                    <td>
                      <div class="image-with-timestamp avoid-pdf-break">
                        <img *ngIf="batchDetails?.quantity_image" [src]="batchDetails?.quantity_image"
                          alt="Quantity Image" class="test-image avoid-pdf-break" />
                        <div *ngIf="batchDetails?.quantity_image && batchDetails?.qty_img_time" class="timestamp">
                          {{ formatTimestamp(batchDetails.qty_img_time) }}
                        </div>
                        <span *ngIf="!batchDetails?.quantity_image">-</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noBatchData>
              <div class="no-data-section">
                <p>No Batch Data Found</p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <ng-template #noInventoryData>
        <div class="no-data-section">
          <p>No Inventory Data Found</p>
        </div>
      </ng-template>
    </div>

    <div class="section">
      <h2 class="section-title">4. Deviations Details Summary</h2>

      <h2 class="section-title mt-3">4.1 QTY Deviations</h2>
      <div *ngIf="productHistoryData?.deviations?.quantity_deviation?.length > 0; else noQtyDeviations">
        <table class="data-table mt-1">
          <thead>
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Item Name</th>
              <th>Batch Number</th>
              <th>Added QTY</th>
              <th>Variation Limit</th>
              <th>Variation %</th>
              <th>Required QTY</th>
              <th>Actual Variation</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let qtyDeviationDetails of productHistoryData?.deviations?.quantity_deviation; let i = index">
              <td>{{ i + 1 }} .</td>
              <td>{{ qtyDeviationDetails?.product_name || '-' }}</td>
              <td>{{ qtyDeviationDetails?.item_name || '-' }}</td>
              <td>{{ qtyDeviationDetails?.batch_no || '-' }}</td>
              <td>{{ qtyDeviationDetails?.added_quantity || '0.00' }}</td>
              <td>{{ qtyDeviationDetails?.variation_limit || '0.00' }}</td>
              <td>{{ qtyDeviationDetails?.variation_percentage || '0.00' }}</td>
              <td>{{ qtyDeviationDetails?.required_quantity || '0.00' }}</td>
              <td>{{ qtyDeviationDetails?.actual_variation | number:'1.2-2' || '0.00' }}</td>
              <td>{{ qtyDeviationDetails?.remarks || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noQtyDeviations>
        <div class="no-data-section">
          <p>No Quantity Deviations Data Found</p>
        </div>
      </ng-template>

      <h2 class="section-title mt-3">4.2 Sequence Deviations</h2>
      <div *ngIf="productHistoryData?.deviations?.sequence_deviation?.length > 0; else noSequenceDeviations">
        <div class="product-card">
          <div class="row align-items-center">
            <div class="col-6">
              <table class="info-table">
                <tr>
                  <td><strong>Batch Number :</strong></td>
                  <td>{{ productHistoryData?.deviations?.sequence_deviation[0]?.batch_no || '-' }}</td>
                </tr>
              </table>
            </div>
            <div class="col-6">
              <table class="info-table">
                <tr>
                  <td><strong>Product Name :</strong></td>
                  <td>{{ productHistoryData?.deviations?.sequence_deviation[0]?.product_name || '-' }}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row align-items-center mt-3">
            <div class="col-6">
              <h2 class="section-title mt-3">Defined Sequence</h2>
              <div
                *ngIf="productHistoryData?.deviations?.sequence_deviation[0]?.define_sequence?.length > 0; else noDefinedSequence">
                <table class="data-table mt-1">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item Name</th>
                      <th>Stage</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let sequenceDeviationDetails of productHistoryData?.deviations?.sequence_deviation[0]?.define_sequence; let i = index">
                      <td>{{ i + 1 }} .</td>
                      <td>{{ sequenceDeviationDetails?.item_name || '-' }}</td>
                      <td>{{ sequenceDeviationDetails?.stage || '-' }}</td>
                      <td>{{ sequenceDeviationDetails?.quantity || '0.00' }} {{ sequenceDeviationDetails?.uom_name || ''
                        }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noDefinedSequence>
                <div class="no-data-section">
                  <p>No Defined Sequence Data Found</p>
                </div>
              </ng-template>
            </div>

            <div class="col-6">
              <h2 class="section-title mt-3">Actual Sequence</h2>
              <div
                *ngIf="productHistoryData?.deviations?.sequence_deviation[0]?.actual_sequence?.length > 0; else noActualSequence">
                <table class="data-table mt-1">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item Name</th>
                      <th>Stage</th>
                      <th>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let sequenceDeviationDetails of productHistoryData?.deviations?.sequence_deviation[0]?.actual_sequence; let i = index">
                      <td>{{ i + 1 }} .</td>
                      <td>{{ sequenceDeviationDetails?.item_name || '-' }}</td>
                      <td>{{ sequenceDeviationDetails?.stage || '-' }}</td>
                      <td>{{ sequenceDeviationDetails?.quantity || '0.00' }} {{ sequenceDeviationDetails?.uom_name || ''
                        }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noActualSequence>
                <div class="no-data-section">
                  <p>No Actual Sequence Data Found</p>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noSequenceDeviations>
        <div class="no-data-section">
          <p>No Sequence Deviations Data Found</p>
        </div>
      </ng-template>

      <h2 class="section-title mt-3">4.3 Loss Deviation</h2>
      <div *ngIf="productHistoryData?.deviations?.loss_deviation?.length > 0; else noLossDeviations">
        <table class="data-table mt-1">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Batch Number</th>
              <th>Initial QTY</th>
              <th>Actual Output QTY</th>
              <th>Charged QTY</th>
              <th>Loss %</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let lossDeviationDetails of productHistoryData?.deviations?.loss_deviation;">
              <td>{{ lossDeviationDetails?.product_name || '-' }}</td>
              <td>{{ lossDeviationDetails?.batch_no || '-' }}</td>
              <td>{{ lossDeviationDetails?.initial_qty || '0.00' }}</td>
              <td>{{ lossDeviationDetails?.actual_output_qty | number:'1.2-2' || '0.00' }}</td>
              <td>{{ lossDeviationDetails?.charged_qty || '0.00' }}</td>
              <td>{{ lossDeviationDetails?.loss_percentage || '0.00' }} %</td>
              <td>{{ lossDeviationDetails?.remarks || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noLossDeviations>
        <div class="no-data-section">
          <p>No Loss Deviations Data Found</p>
        </div>
      </ng-template>

      <h2 class="section-title mt-3">4.4 Cycle Time Deviation</h2>
      <div *ngIf="productHistoryData?.deviations?.cycle_time_deviation?.length > 0; else noCycleTimeDeviations">
        <table class="data-table mt-1">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Batch Number</th>
              <th>Defined Cycle Time</th>
              <th>Percentage Deviation from Std</th>
              <th>Actual Cycle Time</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cycleTimeDeviationDetails of productHistoryData?.deviations?.cycle_time_deviation;">
              <td>{{ cycleTimeDeviationDetails?.product_name || '-' }}</td>
              <td>{{ cycleTimeDeviationDetails?.batch_no || '-' }}</td>
              <td>{{ cycleTimeDeviationDetails?.std_cycle_time || '0.00' }}</td>
              <td>{{ cycleTimeDeviationDetails?.percentage_deviation_from_std || '0.00' }}</td>
              <td>{{ cycleTimeDeviationDetails?.actual_cycle_time | number:'1.2-2' || '0.00' }}</td>
              <td>{{ cycleTimeDeviationDetails?.remarks || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noCycleTimeDeviations>
        <div class="no-data-section">
          <p>No Cycle Time Deviations Data Found</p>
        </div>
      </ng-template>
    </div>

    <div class="section">
      <h2 class="section-title">5. Process Adjustment Summary</h2>
      <div *ngIf="productHistoryData?.stagewise_lists?.length > 0; else noProcessAdjustments">
        <div class="product-card">
          <h2 class="section-title">Parameters</h2>
          <div *ngFor="let parameters of productHistoryData?.stagewise_lists; let i = index">
            <div class="row align-items-center border-line">
              <div class="col-4">
                <table class="info-table">
                  <tr>
                    <td><strong>Stage :</strong></td>
                    <td>{{ parameters?.stage || '-' }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-4">
                <table class="info-table">
                  <tr>
                    <td><strong>RPM :</strong></td>
                    <td>{{ parameters?.RPM || '-' }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-4">
                <table class="info-table">
                  <tr>
                    <td><strong>Mixing Time :</strong></td>
                    <td>{{ parameters?.mixing_time || '-' }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noProcessAdjustments>
        <div class="no-data-section">
          <p>No Process Adjustments Data Found</p>
        </div>
      </ng-template>
    </div>

    <div class="section">
      <h2 class="section-title">6. Quality Control Process Results Summary</h2>
      <div *ngIf="productHistoryData?.production_qc_lists?.length > 0; else noQcData">
        <div class="product-card">
          <div class="row mt-2 align-items-center border-line"
            *ngFor="let qcDetail of productHistoryData?.production_qc_lists; let i = index">
            <div class="col-1"><strong>{{ i + 1 }} .</strong></div>
            <div class="col-6">
              <table class="info-table">
                <tr>
                  <td><strong>Technician :</strong></td>
                  <td>{{ qcDetail?.technician?.employee_name || '-' }}</td>
                </tr>
                <tr>
                  <td><strong>Decision :</strong></td>
                  <td>{{ qcDetail?.decision || '-' }}</td>
                </tr>
                <tr>
                  <td><strong>Reason :</strong></td>
                  <td>{{ qcDetail?.reason || '-' }}</td>
                </tr>
              </table>
            </div>
            <div class="col-5">
              <table class="info-table">
                <tr>
                  <td><strong>Status :</strong></td>
                  <td>{{ qcDetail?.status || '-' }}</td>
                </tr>
                <tr>
                  <td><strong>Started At:</strong></td>
                  <td>{{ formatDate(qcDetail?.createdAt) || '-' }}</td>
                </tr>
                <tr>
                  <td><strong>Completed At :</strong></td>
                  <td>{{ formatDate(qcDetail?.completed_date_time) || '-' }}</td>
                </tr>
              </table>
            </div>
            <h4 class="mt-3 text-center"><strong>QC Test Results</strong></h4>
            <div *ngIf="qcDetail?.qc_methods?.length > 0; else noQcMethodsData">
              <table class="data-table mt-1">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Method Name</th>
                    <th>Test Type</th>
                    <th>Technician</th>
                    <th>Method Code</th>
                    <th>UOM</th>
                    <th>Minimum</th>
                    <th>Maximum</th>
                    <th>Test Result</th>
                    <th>Test Image & Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let qcTestResults of qcDetail?.qc_methods; let i = index">
                    <td>{{ i + 1 }} .</td>
                    <td class="text-start">{{ qcTestResults?.test_method_name || '-' }}</td>
                    <td>{{ qcTestResults?.test_type || '-' }}</td>
                    <td>
                      <span *ngIf="qcTestResults?.test_result; else noTechnician">
                        {{ qcTestResults?.technician_name || qcDetail?.technician?.employee_name || '-' }}
                      </span>
                      <ng-template #noTechnician>-</ng-template>
                    </td>
                    <td>{{ qcTestResults?.test_method_code || '-' }}</td>
                    <td>{{ qcTestResults?.uom_name || '-' }}</td>
                    <td>{{ qcTestResults.minimum | number:'1.2-2' || '-' }}</td>
                    <td>{{ qcTestResults.maximum | number:'1.2-2' || '-' }}</td>
                    <!-- <td>{{ qcTestResults.test_result || '-' }}</td> -->
                    <td [ngClass]="{'text-danger': shouldShowRed(qcTestResults)}">
                      {{ qcTestResults.test_result || '-' }}
                    </td>
                    <td>
                      <div class="image-with-timestamp avoid-pdf-break">
                        <img *ngIf="qcTestResults.test_image" [src]="qcTestResults.test_image" alt="Test Image"
                          class="test-image avoid-pdf-break" />
                        <div *ngIf="qcTestResults.test_image && qcTestResults.test_image_time" class="timestamp">
                          {{ formatTimestamp(qcTestResults.test_image_time) }}
                        </div>
                        <span *ngIf="!qcTestResults?.test_image">-</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noQcMethodsData>
              <div class="no-data-section">
                <p>No QC Methods Data Found</p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <ng-template #noQcData>
        <div class="no-data-section">
          <p>No Quality Control Data Found</p>
        </div>
      </ng-template>
    </div>

    <div class="section">
      <h2 class="section-title">7. Packing Detail Summary</h2>
      <div *ngIf="productHistoryData?.packing_lists?.length > 0; else noPackingData">
        <div class="product-card" *ngFor="let packingDetails of productHistoryData?.packing_lists; let i = index">
          <div class="border-line">
            <div class="row align-items-center">
              <div class="col-1">
                <h4><strong>{{ i + 1 }} .</strong></h4>
              </div>
              <div class="col-6">
                <table class="info-table">
                  <tr>
                    <td><strong>Product Name :</strong></td>
                    <td><strong>{{ packingDetails?.products[0]?.item_name || '-' }}</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Product Code :</strong></td>
                    <td>{{ packingDetails?.products[0]?.item_code || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Quantity :</strong></td>
                    <td>{{ packingDetails?.products[0]?.quantity || '0.00' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Volume in Kg :</strong></td>
                    <td>{{ packingDetails?.pack_volume_in_kg | number:'1.2-2' || '0.00' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Volume in Ltr :</strong></td>
                    <td>{{ packingDetails?.pack_volume_in_ltr | number:'1.2-2' || '0.00' }}</td>
                  </tr>
                  <tr>
                    <td><strong>SG :</strong></td>
                    <td>{{ packingDetails?.specific_gravity | number:'1.2-2' || '0.00' }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-5">
                <table class="info-table">
                  <tr>
                    <td><strong>Filter No :</strong></td>
                    <td>{{ packingDetails?.filter_no || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Verified By :</strong></td>
                    <td>{{ packingDetails?.verified_by || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Packed By :</strong></td>
                    <td>{{ packingDetails?.packed_by || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Tank No :</strong></td>
                    <td>{{ packingDetails?.tank_no || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Completed Date :</strong></td>
                    <td>{{ formatDate(packingDetails?.pre_complete_updated_time) || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Operators :</strong></td>
                    <td>
                      <div *ngIf="packingDetails?.operator_employees?.length > 0; else noOperators">
                        <ol>
                          <li *ngFor="let operator of packingDetails?.operator_employees">{{ operator?.employee_name
                            || '-'
                            }}</li>
                        </ol>
                      </div>
                      <ng-template #noOperators>
                        <p>No Operators Data Found</p>
                      </ng-template>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noPackingData>
        <div class="no-data-section">
          <p>No Packing Data Found</p>
        </div>
      </ng-template>
    </div>

    <!-- Footer -->
    <div class="report-footer">
      <div class="row">
        <div class="col-6">
          <!-- <p><strong>Generated On:</strong> {{ currentDate | date:'medium' }}</p> -->
          <!-- <p><strong>Generated On:</strong> </p> -->
        </div>
        <div class="col-6 text-end">
          <!-- <p><strong>Page 1 of 1</strong></p> -->
          <!-- <p><strong>Page <span class="page-number"></span> of <span class="total-pages"></span></strong></p> -->
        </div>
      </div>
      <!-- <div class="footer-signature">
        <p>Authorized Signature</p>
        <div class="signature-line"></div>
      </div> -->
    </div>
  </div>

  <!-- No Data Message -->
  <div *ngIf="!productHistoryData && !isLoader" class="no-data">
    <div class="alert alert-warning text-center">
      <h4>No Data Available</h4>
      <p>Unable to load production summary data.</p>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading production data...</p>
  </div>
</ng-template>